import { Constants } from '@bingads-webui-clientcenter/entity-utils';

export const IORecommendationTypesToFetch = [
  Constants.RecommendationType.InsertionOrderCreation,
  Constants.RecommendationType.InsertionOrderUpdate,
  Constants.RecommendationType.RecurringInsertionOrderAdd,
];

export const AccountPausedWarningType = [
  Constants.NotificationType.InsertionOrderBalanceDepletedEvent,
  Constants.NotificationType.InsertionOrderExpiredEvent,
];

export const IOExpiringWarningType = [
  Constants.NotificationType.InsertionOrderExpiringUrgentEvent,
];

export const IOExhaustingWarningType = [
  Constants.NotificationType.InsertionOrderExhaustingUrgentEvent,
];

const LogsPrefix = 'IONotifications';
export const LogsScenario = {
  Default: LogsPrefix,
  Displayed: `${LogsPrefix}_Displayed`,
  BillingSummaryDisplayed: `${LogsPrefix}_BillingSummaryDisplayed`,
  AccountPerformanceDisplayed: `${LogsPrefix}_AccountPerformanceDisplayed`,
  AccountPausedWarningDismiss: `${LogsPrefix}_AccountPausedWarningDismiss`,
  CustomerExpiringWarningDismiss: `${LogsPrefix}_CustomerExpiringWarningDismiss`,
  CustomerExhaustingWarningDismiss: `${LogsPrefix}_CustomerExhaustingWarningDismiss`,
  AccountExpiringWarningDismiss: `${LogsPrefix}_AccountExpiringWarningDismiss`,
  AccountExhaustingWarningDismiss: `${LogsPrefix}_AccountExhaustingWarningDismiss`,
  RecommendationDismiss: `${LogsPrefix}_RecommendationDismiss`,
  AccountPausedWarningJump: `${LogsPrefix}_AccountPausedWarningJump`,
  CustomerExpiringWarningJump: `${LogsPrefix}_CustomerExpiringWarningJump`,
  CustomerExhaustingWarningJump: `${LogsPrefix}_CustomerExhaustingWarningJump`,
  AccountExpiringWarningJump: `${LogsPrefix}_AccountExpiringWarningJump`,
  AccountExhaustingWarningJump: `${LogsPrefix}_AccountExhaustingWarningJump`,
  RecommendationJump: `${LogsPrefix}_RecommendationJump`,
};
